import helper from '../helper'

const endpoint = 'api/v1/coupon-claimers'

export const serviceCouponClaimers = {
  get: (token, params) => helper.get(endpoint, token, params),
  countUniquePhone: (token, params) =>
    helper.get(`${endpoint}/count-unique-phone`, token, params),
  getSimilar: (token, claimerid, params) =>
    helper.get(`${endpoint}/similar/${claimerid}`, token, params),
  getAll: (token, params) => helper.get(`${endpoint}/all`, token, params)
}
